import React from 'react';
import { FormattedMessage } from 'react-intl';
import Box from 'carbon-react/lib/components/box';
import { LoaderSpinner } from 'carbon-react/lib/components/loader-spinner';

import { ToastMessage } from '@futrli/ui-components';

interface ForecastUpdatingProps {
  show?: boolean;
}

export const ForecastUpdating = ({ show }: ForecastUpdatingProps) => (
  <ToastMessage open={!!show} variant="neutral">
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <LoaderSpinner showSpinnerLabel={false} size="extra-small" mr="8px" />
      <FormattedMessage defaultMessage="Updating your numbers" id="common.updating_your_numbers" />
    </Box>
  </ToastMessage>
);
